document.addEventListener('DOMContentLoaded', () => {
    const breakpoint = window.matchMedia('(max-width: 600px)');
    const pairs = [];
    document.querySelectorAll('.footer-columns .nav-heading.wp-block-heading').forEach((heading, index) => {
        const nav = heading.nextElementSibling;
        if (!nav?.matches('nav.footer-nav')) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'footer-nav-toggle';
        button.textContent = heading.textContent;
        nav.id ||= `footer-navigation-${index}`;
        button.setAttribute('aria-controls', nav.id);
        button.hidden = true;
        const label = document.createElement('span');
        label.textContent = heading.textContent;
        heading.replaceChildren(label, button);
        const setOpen = open => {
            heading.classList.toggle('active', open);
            nav.classList.toggle('active', open);
            button.setAttribute('aria-expanded', String(open));
            const hidden = breakpoint.matches && !open;
            nav.inert = hidden;
            nav.setAttribute('aria-hidden', String(hidden));
        };
        button.addEventListener('click', () => {
            const open = button.getAttribute('aria-expanded') !== 'true';
            pairs.forEach(pair => pair.setOpen(false));
            setOpen(open);
        });
        pairs.push({label, button, setOpen});
    });
    const update = () => pairs.forEach(({label, button, setOpen}) => {
        label.hidden = breakpoint.matches;
        button.hidden = !breakpoint.matches;
        setOpen(false);
    });
    breakpoint.addEventListener('change', update);
    update();
});
